import { useQuery } from '@tanstack/react-query'
import { CloseIcon, Label, Search, Text } from '@viapeople/components'
import { useMemo, useState } from 'react'
import { trpc } from '../../../utils/trpc'

interface AddVariablesProps {
	onClose: () => void
}
export const AddVariables = ({ onClose }: AddVariablesProps) => {
	const [searchValue, setSearchValue] = useState<string>('')
	const [copied, setCopied] = useState<string | null>(null)
	const { data } = useQuery({
		...trpc.admin.emailTemplates.listVariables.queryOptions(),
	})

	const handleCopy = (label: string) => {
		navigator.clipboard.writeText(`{{ ${label} }}`)
		setCopied(label)
		setTimeout(() => setCopied(null), 1500)
	}

	const filteredData = useMemo(
		() =>
			data?.filter((variable) => !searchValue || variable.name.toLowerCase().includes(searchValue.toLowerCase())) ?? [],
		[data, searchValue],
	)

	return (
		<>
			<div className='py-5 px-6 flex justify-between items-center'>
				<Text id='modal-title' variant='medium' weight='semibold'>
					{'Add variables'}
				</Text>
				<button
					type='button'
					onClick={onClose}
					className='text-neutral-500 hover:text-neutral-700 transition-colors p-1 rounded-full hover:bg-neutral-100 cursor-pointer'
					aria-label='Close modal'>
					<CloseIcon />
				</button>
			</div>
			<div className='mt-4'>
				<Search placeholder='Search' onChange={(event) => setSearchValue(event.target.value)} value={searchValue} />
			</div>

			<div className='flex flex-wrap flex-row gap-4 mt-4'>
				{filteredData.map((variable) => (
					<button
						type='button'
						key={variable.key}
						className='relative cursor-pointer group inline-block'
						onClick={() => handleCopy(variable.key)}>
						<Label variant='outline' className='w-fit'>
							{variable.name}
						</Label>
						{copied === variable.key && (
							<span className='absolute top-0 left-1/2 transform -translate-x-1/2 text-xs text-white bg-green-600 px-2 py-1 rounded mt-[-0.5rem] z-10'>
								Copied!
							</span>
						)}
						<span className='invisible group-hover:visible absolute z-10 w-full px-2 py-1 text-sm text-white bg-neutral-600 text-center rounded-md bottom-full left-1/2 transform -translate-x-1/2 mb-1'>
							{variable.description}
						</span>
					</button>
				))}
			</div>
		</>
	)
}
